import React, { useCallback, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Stack from '@material-ui/core/Stack';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'dva';
import { useLocation } from 'umi';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { SelectFieldCom, TextFieldCom } from './FormType';
import SearchStyled from './SearchStyles';

export default ({ keepParams, searchRef }) => {
  const { control, setValue, watch, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { name, appId } = query;
  const miniProgramAccountList =
    useSelector((state) => state.addAutoReplyRule.miniProgramAccountList) || [];
  const watchAllFields = watch();

  //获取公众号列表
  const fetchAppIdList = useCallback(() => {
    dispatch({
      type: 'addAutoReplyRule/getMiniProgramAccountList',
      payload: {
        values: {},
      },
      callback: (res) => {
        //初始默认选中第一个
        const data = res?.data || [];
        const params = {
          ...query,
          appId: appId ? appId : data[0].appId,
        };
        keepParams && keepParams(params);
        !appId ? setValue('appId', data?.[0]?.appId) : setValue('appId', appId);
      },
    });
  }, [dispatch, setValue, appId]);
  useEffect(() => {
    fetchAppIdList();
  }, [fetchAppIdList]);

  const selectCallBack = (value) => {
    const newParams = {
      ...query,
      appId: value,
      pageNum: 1,
      isSearchStatus: true,
    };
    keepParams && keepParams(newParams);
  };

  //点击重置按钮
  const handleRestClick = () => {
    let newParams = {
      ...query,
      pageNum: 1,
      name: '',
      qrCodeGroupName: '',
    };
    setValue('qrCodeGroupName', '');
    setValue('name', '');
    keepParams && keepParams(newParams);
  };

  //点击查询
  const handleSubmitSuccess = (data) => {
    const newParams = { ...query, ...data, pageNum: 1, isSearchStatus: true };
    keepParams && keepParams(newParams);
  };

  return (
    <SearchStyled>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Stack direction="row" spacing={0.5}>
          <Paper
            elevation={0}
            sx={{ borderRadius: '12px', padding: '24px 32px' }}
          >
            <Box width="240px">
              <SelectFieldCom
                typeList={miniProgramAccountList || []}
                label="小程序"
                control={control}
                name="appId"
                watchAllFields={watchAllFields}
                setValue={setValue}
                fieldNames={{ label: 'nickName', value: 'appId' }}
                noNeed={true}
                selectCallBack={selectCallBack}
              />
            </Box>
          </Paper>
          <Paper
            elevation={0}
            sx={{
              borderRadius: '12px',
              padding: '24px 32px',
              display: 'flex',
              justifyContent: 'space-between',
              flex: 1,
            }}
          >
            <Box display="flex" gap="0 48px">
              <Box width="240px">
                <TextFieldCom
                  label="小程序码分组名称"
                  control={control}
                  name="name"
                  setValue={setValue}
                  defaultValue={name}
                />
              </Box>
            </Box>
            <Box className="button-group">
              <Button
                variant="contained"
                color="secondary"
                className="reset"
                startIcon={
                  <ReplayIcon sx={{ width: '16px', height: '16px' }} />
                }
                onClick={handleRestClick}
              >
                重置
              </Button>

              <Button
                data-log={JSON.stringify({
                  oid: 'btn_miniprogram_qrcode_management_list_search',
                  events: ['_ev'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                ref={searchRef}
                variant="contained"
                type="submit"
                className="search"
                startIcon={
                  <SearchIcon sx={{ width: '16px', height: '16px' }} />
                }
              >
                查询
              </Button>
            </Box>
          </Paper>
        </Stack>
      </form>
    </SearchStyled>
  );
};
